import {
  BudgetItemsForProjectDocument,
  type BudgetItemsForProjectQuery,
  type BudgetItemsForProjectQueryVariables,
} from "@src/__generated__/graphql";
import type { IOption } from "@src/components/ui-kit";
import { FetchHelper } from "@src/helpers/apollo/fetch";
import mapToOptions from "@src/utils/map-to-options";
import { action, computed, makeObservable, observable } from "mobx";

export class BudgetItemSelectStore {
  @observable.ref options: IOption[] = [];

  private fetcher = new FetchHelper<
    BudgetItemsForProjectQuery,
    BudgetItemsForProjectQueryVariables
  >(BudgetItemsForProjectDocument);

  constructor() {
    makeObservable(this);
  }

  @computed get isLoading() {
    return this.fetcher.isLoading.value;
  }

  @action.bound async fetchOptions(projectId: string) {
    const [data, error] = await this.fetcher.fetch({
      projectId,
    });

    if (error) {
      this.clearOptions();
      return;
    }

    this.options = [];

    for (const ourWork of data?.project?.ourWorkStructured ?? []) {
      if (!ourWork?.budgetItems) continue;
      this.options.push(...mapToOptions.budgetItems(ourWork.budgetItems));
    }
  }

  @action.bound clearOptions() {
    this.options = [];
  }
}
